module.exports = __webpack_public_path__ + "horizontalLogo-d4224c89354679337e0c8ebc649816fc.png";